// One page-wide order of events that must be compared for FRESHNESS (#6772): when a read's
// request started, and when a move's 201 landed or a mutation was sent. A counter, not the
// clock: a read the 201 itself starts can begin in the same millisecond as the 201 landed, and
// "started after" must still hold for it. Only order is compared, never a span of time.

let last = 0;

/** The next point in the page's order: strictly after every earlier stamp. */
export function orderStamp(): number {
  last += 1;
  return last;
}
